export default "__VITE_ASSET__a95abc4f__"